import { theme } from '@/presentation/styles'
import { useTheme as useThemePaper } from 'react-native-paper'

export type AppTheme = typeof theme

export const useTheme = (): AppTheme => useThemePaper<AppTheme>()
